import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { FileSelectEvent, FileUpload } from 'primeng/fileupload';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-chat-input-file-upload',
  templateUrl: './chat-input-file-upload.component.html',
  styleUrl: './chat-input-file-upload.component.scss',
})
export class ChatInputFileUploadComponent {
  @Input() accept: string;
  @ViewChild(FileUpload) fileUpload: FileUpload | undefined;
  @Output() onFileSelected: EventEmitter<File[]> = new EventEmitter();

  protected readonly MAX_FILE_SIZE: number = 200000000;
  protected isUploading = false;
  public customNames = new Map<File, string>();
  protected totalSize: number = 0;
  protected maxFiles = 20;

  @Input() set files(value: File[] | undefined) {
    if (this.fileUpload && value) {
      this.fileUpload.files = value;
    }
  }

  get files(): File[] | undefined {
    return this.fileUpload?.files;
  }

  constructor(private readonly messageService: MessageService) {}

  protected onSelectedFiles(event: FileSelectEvent) {
    this.customNames.clear();
    const files = event.files;
    Array.from(files)?.forEach((f) => {
      this.customNames?.set(f, f.name);
    });
    this.totalSize =
      this.files?.reduce((sum, current) => sum + current.size, 0) || 0;
    const filesWithoutDuplicities = Array.from(new Set([...this.files]));

    if (filesWithoutDuplicities.length > this.maxFiles) {
      filesWithoutDuplicities.splice(this.maxFiles);
      this.messageService.add({
        severity: 'error',
        summary: 'Max files exceeded',
        detail: `You can only upload ${this.maxFiles} files.`,
      });
    }

    this.onFileSelected.emit(filesWithoutDuplicities);
  }
}
